import { useMemo } from 'react'

import { useOrganizationUiSetup } from '../../../hooks/useOrganizationUiSetup'
import { isShineAccount } from '../../../utils/accountTypeCheckers'
import { useBookkeepingBankAccounts } from '../../accounts/hooks/useBookkeepingBankAccounts'

export const useCanConnectToShineBank = () => {
  const { bookkeepingBankAccounts } = useBookkeepingBankAccounts()
  const { isUiSetupShineInvoicingAccounting, isUiSetupSupernavInvoicingAccounting } = useOrganizationUiSetup()

  const hasShineBookkeepingBankAccount = useMemo(
    () => bookkeepingBankAccounts.some((account) => isShineAccount(account)),
    [bookkeepingBankAccounts],
  )
  const canConnectToShineBank =
    (isUiSetupShineInvoicingAccounting || isUiSetupSupernavInvoicingAccounting) && !hasShineBookkeepingBankAccount

  return {
    canConnectToShineBank,
  }
}
